export interface FileHandle {
  file: File;
  url: string;
}

export const toFileHandle = (file: File) => {
  const url = window.URL.createObjectURL(file);
  return { file, url };
};
